import { useEffect, useState } from 'react';
import { Rows3, Rows4 } from 'lucide-react';

const KEY = 'hj_density';

/** Row density, remembered per browser. Applies to every table in the app
 *  through the --row-* tokens, so a short laptop screen can show ~40% more
 *  rows without anyone zooming out. */
export const DensityToggle = () => {
  const [compact, setCompact] = useState(() => {
    try { return localStorage.getItem(KEY) === 'compact'; } catch { return false; }
  });

  useEffect(() => {
    document.documentElement.dataset.density = compact ? 'compact' : 'default';
    try { localStorage.setItem(KEY, compact ? 'compact' : 'default'); } catch { /* private mode */ }
  }, [compact]);

  return (
    <button
      onClick={() => setCompact(v => !v)}
      title={compact ? 'Comfortable rows' : 'Compact rows — fit more on screen'}
      aria-pressed={compact}
      data-testid="density-toggle"
      className="h-8 w-8 flex items-center justify-center rounded-ui text-ink-3 hover:text-ink-1 hover:bg-surface-2 transition-colors"
    >
      {compact ? <Rows3 className="w-4 h-4" /> : <Rows4 className="w-4 h-4" />}
    </button>
  );
};

export default DensityToggle;
